"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListFieldConfigBuilder = exports.ValueFieldConfigBuilder = exports.ObjectConfigBuilder = exports.f = void 0;
const rules_1 = require("./rules");
/**
 * Provides a Zod-ish API for building form configs.
 */
exports.f = {
    /** Creates the top-level config for a form, like an author or book. */
    config(fields) {
        return new ObjectConfigBuilder(fields).build().config;
    },
    /** Creates the config DSL for an object, like an author or book. */
    object(fields) {
        return new ObjectConfigBuilder(fields);
    },
    /** Creates the config DSL for an list of objects, like an author's list of books. */
    list(fields) {
        return new ListFieldConfigBuilder(fields);
    },
    /** Creates the config DSL for a primitive value, like a first name or phone number. */
    value() {
        return new ValueFieldConfigBuilder();
    },
    /** A shortcut for creating a child object with a single `id` key. */
    reference(fields) {
        return exports.f.object({ id: exports.f.value(), ...fields }).ref();
    },
    /** A shorthand for creating a computed value. */
    computed() {
        return this.value().computed();
    },
};
/** Provides a fluent DSL for building up an object's config. */
class ObjectConfigBuilder {
    constructor(fields) {
        this.config = { type: "object", config: {} };
        for (const [key, value] of Object.entries(fields)) {
            this.config.config[key] = value.build();
        }
    }
    ref() {
        this.config.reference = true;
        return this;
    }
    build() {
        return this.config;
    }
}
exports.ObjectConfigBuilder = ObjectConfigBuilder;
/** Provides a fluent DSL for building up a value's config. */
class ValueFieldConfigBuilder {
    constructor() {
        this.config = { type: "value", rules: [] };
    }
    /** Marks the field as required. */
    req() {
        this.config.rules = [rules_1.required];
        return this;
    }
    /** Marks the field as read only. */
    readOnly() {
        this.config.readOnly = true;
        return this;
    }
    /** Appends `rules` to the field's validation rules. */
    rules(rules) {
        var _a;
        var _b;
        ((_a = (_b = this.config).rules) !== null && _a !== void 0 ? _a : (_b.rules = [])).push(...rules);
        return this;
    }
    /** Marks the field as computed. */
    computed() {
        this.config.computed = true;
        return this;
    }
    build() {
        return this.config;
    }
}
exports.ValueFieldConfigBuilder = ValueFieldConfigBuilder;
/** Provides a fluent DSL for building up a list's config. */
class ListFieldConfigBuilder {
    constructor(fields) {
        const config = {};
        for (const [key, value] of Object.entries(fields)) {
            config[key] = value.build();
        }
        this.config = { type: "list", rules: [], config };
    }
    /** Appends `rule` to the field's validation rules. */
    rule(rule) {
        var _a;
        var _b;
        ((_a = (_b = this.config).rules) !== null && _a !== void 0 ? _a : (_b.rules = [])).push(rule);
        return this;
    }
    /** Appends `rules` to the field's validation rules. */
    rules(rules) {
        var _a;
        var _b;
        ((_a = (_b = this.config).rules) !== null && _a !== void 0 ? _a : (_b.rules = [])).push(...rules);
        return this;
    }
    build() {
        return this.config;
    }
}
exports.ListFieldConfigBuilder = ListFieldConfigBuilder;
